import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJObjectEraseRight.module.less';

import FJUtil from '../../../../util/FJUtil';
import FJConstant from '../../../../constants/FJConstant';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJBrushObjectEraseRightContainer from '../container/FJBrushObjectEraseRightContainer';
import FJTextObjectEraseRightContainer from '../container/FJTextObjectEraseRightContainer';
import FJResultActionButtons from '../../../../common/combineComponents/FJResultActionButtons/FJResultActionButtons';

const FJObjectEraseRight = props => {
    const {
        setIsDraggingFile,
        uploadImg,
        headerTabIndex,
        taskStatus,
        downloadEditImageLoading,
        isCanDownload,
        download,
        hasEditImage,
        isShow,
        curMenuIndex,
        imageToVideo,
    } = props;

    const renderDownload = () => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return <div />;
        }

        if (window.isEditPage) return null; // 使用内部的download组件

        return (
            <FJResultActionButtons
                taskStatus={taskStatus}
                headerTabIndex={headerTabIndex}
                isCanDownload={isCanDownload}
                onDownload={download}
                downloadLoading={downloadEditImageLoading}
                isShowImageToVideoButton={true}
                imageToVideo={imageToVideo}
            />
        );
    };

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            disable={FJUtil.isGeneratingStatus(taskStatus)}
            uploadFile={uploadImg}
            className={classNames(styles.app_right, { [styles.show]: isShow })}
        >
            <FJDisplayHeaderContainer
                isShowProgress={false}
                rightChildren={renderDownload()}
                hasEditImage={hasEditImage}
                hideCancelButton={true}
            />

            <FJBrushObjectEraseRightContainer isShow={curMenuIndex === 0} />

            <FJTextObjectEraseRightContainer isShow={curMenuIndex === 1} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};

FJObjectEraseRight.propTypes = {
    setIsDraggingFile: PropTypes.func,
    uploadImg: PropTypes.func,
    headerTabIndex: PropTypes.string,
    taskStatus: PropTypes.string,
    creationList: PropTypes.array,
    downloadEditImageLoading: PropTypes.bool,
    download: PropTypes.func,
    isCanDownload: PropTypes.bool,
    hasEditImage: PropTypes.bool,
    isShow: PropTypes.bool,
    curMenuIndex: PropTypes.number,
    imageToVideo: PropTypes.func,
};

export default FJObjectEraseRight;
